import React, { Component } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { SystemMessage } from "react-chat-elements";

class SystemMessageComponent extends Component {
    render() {
        const { msg, index, dateFormatter } = this.props;

        // Define estilos y colores según el owner_id
        let backgroundColor = "#F0F4F8";
        let iconColor = "#4A90E2";
        let iconType = <InfoCircleOutlined />;

        switch (msg.owner_id) {
            case "new_contact":
                backgroundColor = "#DFF6DD";
                iconColor = "#34A853";
                break;
            case "bot_redirection":
                backgroundColor = "#FFF4E5";
                iconColor = "#F4B400";
                break;
            case "redirection_to_human":
                backgroundColor = "#FFE5E5";
                iconColor = "#EA4335";
                break;
            case "tokeover_chat":
                backgroundColor = "#E5F3FF";
                iconColor = "#4285F4";
                break;
            case "department_redirection":
                backgroundColor = "#EDE7F6";
                iconColor = "#6A1B9A";
                break;
            default:
                backgroundColor = "#F0F4F8";
                iconColor = "#4A90E2";
        }

        return (
            <SystemMessage
                key={index}
                
                text={
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: backgroundColor, // Color de fondo según el caso
                            padding: "10px",
                            borderRadius: "5px",
                        }}
                    >
                        <InfoCircleOutlined
                            style={{
                                fontSize: "26px",
                                color: iconColor, // Color del ícono según el caso
                                paddingRight: "10px",
                                paddingLeft: "10px",
                            }}
                        />
                        <span>
                            {msg.content
                                .split("\n")
                                .map((line, i) => (
                                    <span key={i}>
                                        {line}
                                        <br />
                                    </span>
                                ))}
                            <p style={{ margin: 0, fontSize: "12px", color: "#888" }}>
                                {dateFormatter(msg.timestamp)}
                            </p>
                        </span>
                    </div>
                }
            />
        );
    }
}

export default SystemMessageComponent;



// WEBPACK FOOTER //
// ./src/views/NaduChat/SystemMessage.jsx